export default "__VITE_ASSET__cf8f6a3e__"